import React, { useEffect, useState } from 'react'
import { Button, Form, useNotify, useRecordContext } from 'react-admin'
import { Box, Grid, TextField, Typography } from '@mui/material'
import {
  getCollectorLogicLead,
  sendMessageToCL,
} from '../../../../Utils/RestUtils'

const CollectorLogicPanel = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const [leadResponse, setLeadResponse] = useState(null)
  const [message, setMessage] = useState('')

  const handleSendMessage = async () => {
    const response = await sendMessageToCL(record.originId, message)

    if (response.status === 200) {
      notify('Message sent successfully', { type: 'success' })
      setMessage('')
    } else {
      notify('Failed to send message', { type: 'error' })
    }
  }

  const getDataFromApi = async () => {
    const leadResponse = await getCollectorLogicLead(record.originId)

    if (leadResponse.status !== 200) {
      notify('Could not load collector data', { type: 'error' })
    } else {
      setLeadResponse(leadResponse.data)
    }
  }

  useEffect(() => {
    getDataFromApi()
  }, [])

  return (
    <React.Fragment>
      <Typography className="collection-panel__title" sx={{ paddingBottom: 2 }}>
        Collector Logic
      </Typography>
      <Box sx={{ paddingBottom: 4 }}>
        Status: {leadResponse?.status ? leadResponse?.status : 'N/A'},
        Collection booked in for:{' '}
        {leadResponse?.run_date ? leadResponse?.run_date : 'N/A'}
      </Box>
      <Form>
        <Grid container spacing={1} xs={12}>
          <Grid container spacing={0} xs={12}>
            <Grid item flex={1} xs={12}>
              <TextField
                name="content"
                label="Send note to Collector Logic"
                multiline
                rows={7}
                onChange={(e) => setMessage(e.target.value)}
                value={message}
              />
            </Grid>
            <Grid item flex={1} xs={12}>
              <Button
                type="submit"
                sx={{ float: 'right' }}
                label="Send Message"
                color="primary"
                size="large"
                Ï
                onClick={() => handleSendMessage()}
              />
            </Grid>
          </Grid>
        </Grid>
      </Form>
    </React.Fragment>
  )
}

export default CollectorLogicPanel
